import { Component, Input } from "@angular/core";
import { ReferenceDrawerItemInfo } from "@shared/models/reference-drawer-item-info.model";

@Component({
    selector: "app-reference-drawer-item",
    templateUrl: "./reference-drawer-item.component.html",
    styleUrls: ["./reference-drawer-item.component.css"]
})
export class ReferenceDrawerItemComponent {
    @Input() info!: ReferenceDrawerItemInfo;

    get isAskMyDocsReference(): boolean {
        return this.info.type === 'ASK_MY_DOCS';
    }
}
